import { message } from "antd";
import { useReattachToManagerMutation } from "../../../store/api/listManager.api";
import { ISubmitReattachFunctionParams } from "../../../interfaces/utilities/hooks/ISubmitReattachFunctionParams";

export const useSubmitReattachToManager = () => {
  const [reattachQuery, { isLoading }] = useReattachToManagerMutation();

  const onSubmitReattach = async ({
    personIds,
    type,
    toManagerId,
    fromManagerId,
    afterSuccessQuery,
    afterErrorQuery,
  }: ISubmitReattachFunctionParams) => {
    if (toManagerId) {
      try {
        await reattachQuery({
          type: type,
          humanIds: personIds,
          toManagerId: toManagerId,
          fromManagerId: fromManagerId,
        }).unwrap();
        if (afterSuccessQuery) {
          afterSuccessQuery();
        }
      } catch (e) {
        if (afterErrorQuery) afterErrorQuery(e);
      }
    } else {
      message.error("Выберите ответственного менеджера");
    }
  };

  return { isLoading, onSubmitReattach };
};
